/**
 * Recover first-tap navigation when carousels cancel the browser click.
 * Only forces navigation when pointerup happens on a link but no click event follows.
 */
(function () {
  'use strict';

  var start = null;
  var MOVE_LIMIT = 14;

  function closestNavLink(el) {
    if (!el || !el.closest) return null;
    if (
      el.closest(
        'button, input, select, textarea, label, [data-quickview-trigger], [data-wishlist-toggle], .col-add-btn, .product__add-to-cart, .tb-pcard__gallery-nav-btn, .tb-pcard__shade, #cart-open-button, #menu-open-button, #search-open-button'
      )
    ) {
      return null;
    }
    var link = el.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return null;
    return link;
  }

  function onPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var link = closestNavLink(e.target);
    if (!link) {
      start = null;
      return;
    }
    start = {
      link: link,
      x: e.clientX,
      y: e.clientY,
      at: Date.now(),
      moved: false
    };
  }

  function onPointerMove(e) {
    if (!start) return;
    if (Math.abs(e.clientX - start.x) > MOVE_LIMIT || Math.abs(e.clientY - start.y) > MOVE_LIMIT) {
      start.moved = true;
    }
  }

  function onPointerUp(e) {
    if (!start) return;
    var info = start;
    start = null;
    if (info.moved) return;
    if (Date.now() - info.at > 700) return;

    var link = closestNavLink(e.target);
    if (!link || link !== info.link) return;

    var clickFired = false;
    var onClick = function (ev) {
      if (ev.target === link || (ev.target.closest && link.contains(ev.target))) {
        clickFired = true;
      }
    };
    document.addEventListener('click', onClick, true);

    window.setTimeout(function () {
      document.removeEventListener('click', onClick, true);
      // Browser click happened — let it proceed (even if something else handles it).
      if (clickFired) return;
      if (document.body.classList.contains('sidebar-opened')) return;
      if (document.querySelector('.page-overlay.show-quickview-overlay')) return;
      try {
        window.location.assign(link.href);
      } catch (err) {}
    }, 50);
  }

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointerup', onPointerUp, true);
})();
